export interface Instruction {
  action: string;
  target: string;
}

export interface StatusMessage {
  success: string;
  error: Instruction;
}
